// extracted by mini-css-extract-plugin
export default {"mainContainer":"ProductDetailSmall_mainContainer__K3RqW","priceSection":"ProductDetailSmall_priceSection__fTAKY","icon":"ProductDetailSmall_icon__GUS36"};